import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FavoriteButtonContainer } from './FavoriteButtonContainer';
import { toggleFeaturesActiveStatus } from '../../actions/newbuildingPolygon';
import { closeSearchResultsSidebar } from '../../actions/searchResults';
import { SidebarNewbuildingHeader } from '../../components/SidebarNewbuildingHeader';
import { selectNewbuildingId, selectNewbuildingFicheringPlus } from '../../selectors/features';
import { selectActiveNewbuildingPolygon } from '../../selectors/newbuildingPolygons';
import { TThunkDispatch } from '../../types/redux';
import { trackCloseSidebar } from '../../utils/tracking';
import { useApplicationContext } from '../ApplicationContext';

const COMPARE_ENABLED_CONFIG = 'Newbuilding.Compare.Enabled';

export const SidebarNewbuildingHeaderContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const newbuildingId = useSelector(selectNewbuildingId);
  const isFicheringPlus = useSelector(selectNewbuildingFicheringPlus);
  const { geohashIds } = useSelector(selectActiveNewbuildingPolygon);
  const isCompareEnabled = config.get<boolean>(COMPARE_ENABLED_CONFIG) || false;

  const dispatch = useDispatch<TThunkDispatch>();

  const handleClose = React.useCallback(() => {
    dispatch(closeSearchResultsSidebar());
    trackCloseSidebar(newbuildingId, isFicheringPlus);
    dispatch(toggleFeaturesActiveStatus({ geohashIds, isActive: false }));
  }, [dispatch, newbuildingId, geohashIds, isFicheringPlus]);

  return (
    <SidebarNewbuildingHeader
      favoriteButton={isCompareEnabled ? null : <FavoriteButtonContainer />}
      isCompareEnabled={isCompareEnabled}
      onClose={handleClose}
    />
  );
};

SidebarNewbuildingHeaderContainer.displayName = 'SidebarNewbuildingHeaderContainer';
